import React, { useContext, useEffect, useState } from 'react';
import BarraLateral from '../../Componentes/BarraLateral';
import CorpoPagina from '../../Componentes/CorpoPagina';
import HeaderNavegacao from '../../Componentes/HeaderNavegacao';
import { StoreContexto } from '../../Contexto/Provider';
import '../../Estilos/Container.css';
import '../../Estilos/Wellcome.css';
import { getDocument } from '../../Funções/Conexão';

export default function Wellcome() {
  const [pageUpdated, setPageUpdated] = useState(false);
  const { idLogin, senhaSalva, controleSalvo, nomeSalvo, token } = useContext(StoreContexto);
  useEffect(() => {
    if (!pageUpdated) {
      setPageUpdated(true);
      updateDocument();
    }
  }, []);

  const [doc, setDoc] = useState('');

  const updateDocument = async () => {
    //let d = await getDocument();
    //setDoc(d.info[0].procedimento_referencia);
  };
  return (
    <CorpoPagina wellcome>
      <div className="Itens_Container">
        <div className="Texto_Container">
          <h1 className="Itens_Container">PLATAFORMA DE MONITORAMENTO FACILITIES</h1>

          <h4 className="Itens_Container">
            Bem-vindo à plataforma de monitoramento e controle de umidade e temperatura!
          </h4>
          <h3 style={{ color: '#005288' }}>Procedimento de Referência:13-FS20-1000-00002-AM</h3>
        </div>

        <img src={require('../../Imagens/FACILITIESs.png')} className="Imagem_Wellcome" />
      </div>
    </CorpoPagina>
  );
}
